export default __webpack_public_path__ + "static/media/bp-7.085c482d.png";